import { render, staticRenderFns } from "./UserDemoSetActionButton.vue?vue&type=template&id=67669902"
import script from "./UserDemoSetActionButton.vue?vue&type=script&lang=js"
export * from "./UserDemoSetActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports